module.exports = __webpack_public_path__ + "fonts/Gilroy-Regular.31ff7c1a.ttf";